/* globals google */
export default mainSearch => {
    // console.log('mainSearch');
    // const form = mainSearch.querySelector('form');
    const formSubmit = mainSearch.querySelector('#main-search-submit');

    const mainSearchInputsRadioCats = mainSearch.querySelectorAll('input[name="main-search-radio-cat"]');
    const mainSearchInputsRadioPass = mainSearch.querySelectorAll('input[name="main-search-radio-pass"]');
    const mainSearchInputsRadioGift = mainSearch.querySelectorAll('input[name="main-search-radio-gift"]');

    // const mainSearchPartChoices = mainSearch.querySelector('.main-search-part.choices');
    const searchParts = mainSearch.querySelectorAll('.search-part');
    const searchPartGolf = mainSearch.querySelector('.search-part.golf');
    const searchPartVisit = mainSearch.querySelector('.search-part.visit');
    const searchPartPass = mainSearch.querySelector('.search-part.pass');
    const searchPartGift = mainSearch.querySelector('.search-part.gift');

    const mainSearchInputLocationGolf = mainSearch.querySelector('#main-search-input-location-golf');
    const mainSearchInputLocationVisit = mainSearch.querySelector('#main-search-input-location-visit');

    //const autocompleteOptions = { types: ['geocode'] };
    const autocompleteOptions = {  };
    const autocompleteFields = ['geometry', 'name'];
    const autocompleteInputLocationGolf = new google.maps.places.Autocomplete(mainSearchInputLocationGolf, autocompleteOptions);
    const autocompleteInputLocationVisit = new google.maps.places.Autocomplete(mainSearchInputLocationVisit, autocompleteOptions);

    /*autocompleteInputLocationGolf.addListener('place_changed', function(){
      console.log('change');
      console.log(autocompleteInputLocationGolf.getPlace());
      console.log(autocompleteInputLocationGolf.getPlace().geometry.viewport);
      console.log(autocompleteInputLocationGolf.getPlace().geometry.viewport.getNorthEast().lat());
      console.log(autocompleteInputLocationGolf.getPlace().geometry.viewport.getNorthEast().lng());
      console.log(autocompleteInputLocationGolf.getPlace().geometry.viewport.getSouthWest().lat());
      console.log(autocompleteInputLocationGolf.getPlace().geometry.viewport.getSouthWest().lng());
    });*/

    const prevInputLat = mainSearch.querySelector('#previous-lat');
    const prevInputLong = mainSearch.querySelector('#previous-long');

    const prevInputNorth = mainSearch.querySelector('#previous-north');
    const prevInputEast = mainSearch.querySelector('#previous-east');
    const prevInputSouth = mainSearch.querySelector('#previous-south');
    const prevInputWest = mainSearch.querySelector('#previous-west');

    autocompleteInputLocationGolf.setFields(autocompleteFields);
    autocompleteInputLocationVisit.setFields(autocompleteFields);

    function activePart(event) {
        const dataPart = event.target.getAttribute('data-part');

        for (const searchPart of searchParts) {
            const id = searchPart.getAttribute('id').split('-')[2];

            searchPart.classList.remove('active');

            if (id === dataPart) {
                searchPart.classList.add('active');
            }

            formSubmit.textContent = formSubmit.getAttribute(`data-title-${dataPart}`);
            // formSubmit.setAttribute('disabled', 'disabled');
        }
    }



    function removeAccents(strAccents)  {
      var strAccents = strAccents.split('');
      var strAccentsOut = new Array();
      var strAccentsLen = strAccents.length;
      var accents = 'ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž';
      var accentsOut = "AAAAAAaaaaaaOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz";
      for (var y = 0; y < strAccentsLen; y++) {
        if (accents.indexOf(strAccents[y]) != -1) {
          strAccentsOut[y] = accentsOut.substr(accents.indexOf(strAccents[y]), 1);
        } else
          strAccentsOut[y] = strAccents[y];
      }
      strAccentsOut = strAccentsOut.join('');
      strAccentsOut = strAccentsOut.replace(/ /g,"_");
      strAccentsOut = strAccentsOut.replace(/'/g, '__');
      return strAccentsOut;
    }

    for (const mainSearchInputRadioCats of mainSearchInputsRadioCats) {
        mainSearchInputRadioCats.addEventListener('click', activePart);
    }

    mainSearchInputLocationGolf.addEventListener('blur', () => {
        if (mainSearchInputLocationGolf.value !== '') {
            searchPartGolf.classList.remove('greyed');
        }
    });

    mainSearchInputLocationVisit.addEventListener('blur', () => {
        if (mainSearchInputLocationVisit.value !== '') {
            searchPartVisit.classList.remove('greyed');
        }
    });

    for (const mainSearchInputRadioPass of mainSearchInputsRadioPass) {
        mainSearchInputRadioPass.addEventListener('change', () => {
            searchPartPass.classList.remove('greyed');
        });
    }

    for (const mainSearchInputRadioGift of mainSearchInputsRadioGift) {
        mainSearchInputRadioGift.addEventListener('change', () => {
            searchPartGift.classList.remove('greyed');
        });
    }

    formSubmit.addEventListener('click', event => {
        event.preventDefault();

        const service = new google.maps.places.AutocompleteService();
        const geocoder = new google.maps.Geocoder();
        const dataUrl = mainSearch.getAttribute('data-url');
        let cat = '';
        let place = '';
        let lat = '';
        let lng = '';
        let north = '';
        let east = '';
        let south = '';
        let west = '';
        let loc = '';
        let pacContainer = '';

        //const inputTargetUrl = () => `${dataUrl}cat/${cat}/lat/${lat}/lng/${lng}/loc/${loc}/`;
        const inputTargetUrl = () => `${dataUrl}cat/${cat}/lat/${lat}/lng/${lng}/n/${north}/e/${east}/s/${south}/w/${west}/loc/${loc}/`;

        const nextPage = value => {
            window.location = value;
        };

        for (const mainSearchInputRadioCat of mainSearchInputsRadioCats) {
            if (mainSearchInputRadioCat.checked) {
                cat = mainSearchInputRadioCat.value;
            }
        }

        if (cat === 'golf' || cat === 'visit') {
            const input = cat === 'golf' ? mainSearchInputLocationGolf : mainSearchInputLocationVisit;
            const autocompletInput = cat === 'golf' ? autocompleteInputLocationGolf : autocompleteInputLocationVisit;
            pacContainer = cat === 'golf' ? document.querySelectorAll('.pac-container')[0] : document.querySelectorAll('.pac-container')[1];

            if (input.value.length > 0) {
                input.parentNode.classList.remove('error');
                if (autocompletInput.getPlace() !== undefined) {
                    place = autocompletInput.getPlace();
                    lat = place.geometry.location.lat();
                    lng = place.geometry.location.lng();
                    north = place.geometry.viewport.getNorthEast().lat();
                    east = place.geometry.viewport.getNorthEast().lng();
                    south = place.geometry.viewport.getSouthWest().lat();
                    west = place.geometry.viewport.getSouthWest().lng();
                    loc = removeAccents(place.name);
                    nextPage(inputTargetUrl());
                } else if(prevInputLat != null && prevInputLong != null && autocompletInput.value != ""){
                    place = autocompletInput.getPlace();
                    lat = prevInputLat.value;
                    lng = prevInputLong.value;
                    north = prevInputNorth.value;
                    east = prevInputEast.value;
                    south = prevInputSouth.value;
                    west = prevInputWest.value;
                    loc = removeAccents(input.value);
                    nextPage(inputTargetUrl());
                }else{
                    const firstPacItem = pacContainer.querySelectorAll('.pac-item')[0];

                    let firstResult = firstPacItem.textContent;
                    const stringMatched = firstPacItem.querySelector('.pac-item-query').textContent;

                    firstResult = firstResult.replace(stringMatched, `${stringMatched} `);

                    // service.getQueryPredictions({ input: 'Paris' }, (predictions, serviceStatus) => {
                    service.getPlacePredictions({ input: firstResult }, (predictions, serviceStatus) => {
                        if (serviceStatus !== google.maps.places.PlacesServiceStatus.OK) {
                            // console.log(`AutocompleteService was not successful for the following reason: ${serviceStatus}`);
                        } else {
                            geocoder.geocode({ address: predictions[0].description }, (results, geocodeStatus) => {
                                if (geocodeStatus !== google.maps.GeocoderStatus.OK) {
                                    // console.log(`Geocode was not successful for the following reason: ${geocodeStatus}`);
                                } else {
                                    lat = results[0].geometry.location.lat();
                                    lng = results[0].geometry.location.lng();
                                    north = results[0].geometry.viewport.getNorthEast().lat();
                                    east = results[0].geometry.viewport.getNorthEast().lng();
                                    south = results[0].geometry.viewport.getSouthWest().lat();
                                    west = results[0].geometry.viewport.getSouthWest().lng();
                                    loc = removeAccents(results[0].address_components[0].long_name);

                                    nextPage(inputTargetUrl());
                                }
                            });
                        }
                    });
                }
            } else {
                input.parentNode.classList.add('error');
            }
        } else if (cat === 'pass') {
            for (const mainSearchInputRadioPass of mainSearchInputsRadioPass) {
                if (mainSearchInputRadioPass.checked) {
                    nextPage(mainSearchInputRadioPass.value);
                }
            }
        } else if (cat === 'gift') {
            for (const mainSearchInputRadioGift of mainSearchInputsRadioGift) {
                if (mainSearchInputRadioGift.checked) {
                    nextPage(mainSearchInputRadioGift.value);
                }
            }
        }
    });
};
